import { render } from "./feedbackTracker.vue?vue&type=template&id=0032393f&scoped=true"
import script from "./feedbackTracker.vue?vue&type=script&lang=js"
export * from "./feedbackTracker.vue?vue&type=script&lang=js"

import "./feedbackTracker.vue?vue&type=style&index=0&id=0032393f&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0032393f"]])

export default __exports__